import { AlertTriangle } from 'lucide-react';

const UnassignedWarningModal = ({ onConfirm, onCancel }) => (
<div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fade-in-up">
    <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-[90vw] sm:max-w-md">

        <div className="text-center">
            <AlertTriangle className="mx-auto h-12 w-12 text-yellow-500" />
            <h3 className="mt-2 text-xl font-bold text-gray-800">Unassigned Recovery Plan</h3>
            <p className="mt-2 text-sm text-gray-600">
                Are you sure you want to save this recovery plan as unassigned?
            </p>
        </div>

        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
            <button
                onClick={onCancel}
                className="px-4 py-2 text-gray-700 font-semibold rounded-lg border border-gray-300 hover:bg-gray-100 transition"
            >
                Cancel
            </button>
            <button
                onClick={onConfirm}
                className="px-4 py-2 bg-[#166273] text-white font-semibold rounded-lg shadow-md hover:bg-[#166273]/90 transition"
            >
                Confirm
            </button>
        </div>

    </div>
</div>
);

export default UnassignedWarningModal;